import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, doc, collection, setDoc, updateDoc } from 'firebase/firestore';


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBsfXMtb2khmYpcvynh_ysDoE3oaxkrEbc",
  authDomain: "makao-d5548.firebaseapp.com",
  projectId: "makao-d5548",
  storageBucket: "makao-d5548.appspot.com",
  messagingSenderId: "598733310933",
  appId: "1:598733310933:web:82305fd0a766135c624b5c",
  measurementId: "G-LS3X8VFDKJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
//initialise firestore database
const firestore = getFirestore(app); // Added this line



// Function to create a new event with Step 1 data
export const createEventStepOne = async (eventData) => {
  try {
    // Creating a new document with an auto-generated ID
    const docRef = doc(collection(firestore, "events"));
    await setDoc(docRef, eventData);

    // Returning the doc ID to be used in Step 2
    return docRef.id;
  } catch (error) {
    console.error("Error creating event: ", error);
  }
};

// Function to update the event with Step 2 data
export const updateEventStepTwo = async (docId, eventData) => {
  try {
    const docRef = doc(firestore, "events", docId);
    await updateDoc(docRef, eventData);
  } catch (error) {
    console.error("Error updating event: ", error);
  }
};


export default firestore;

